document.addEventListener("DOMContentLoaded", function () {
  function initShopRoom() {
    document.querySelector(".new-shop-room")?.classList.add("js-initialized");

    const roomBlocks = document.querySelectorAll(".room-block");
    const totalBlocks = roomBlocks.length;
    let currentIndex = 0;

    if (totalBlocks > 1) {
      const prevButton = document.getElementById("prev-room");
      const nextButton = document.getElementById("next-room");

      function showBlock(index) {
        roomBlocks.forEach((block) => block.classList.remove("active"));
        roomBlocks[index].classList.add("active");
        currentIndex = index;

        const currentRoom = roomBlocks[index];
        const firstPickpoint = currentRoom.querySelector(".pickpoint");
        if (firstPickpoint) showProductForPickpoint(firstPickpoint);
      }

      nextButton.addEventListener("click", function () {
        const newIndex = (currentIndex + 1) % totalBlocks;
        showBlock(newIndex);
      });

      prevButton.addEventListener("click", function () {
        const newIndex = (currentIndex - 1 + totalBlocks) % totalBlocks;
        showBlock(newIndex);
      });

      showBlock(0);
    }

    function updatePickpointPositions() {
      const pickpoints = document.querySelectorAll(".pickpoint");
      const isMobile = window.innerWidth <= 768;

      pickpoints.forEach((pickpoint) => {
        let left = isMobile
          ? pickpoint.getAttribute("data-mobile-left")
          : pickpoint.getAttribute("data-desktop-left");
        let top = isMobile
          ? pickpoint.getAttribute("data-mobile-top")
          : pickpoint.getAttribute("data-desktop-top");

        if (left && top) {
          pickpoint.style.left = left + "%";
          pickpoint.style.top = top + "%";
        }
      });
    }

    function showProductForPickpoint(pickpoint) {
      if (!pickpoint) return;

      const block = pickpoint.closest(".room-block");
      if (!block) return;

      const productIndex = pickpoint.getAttribute("data-product-index");
      if (!productIndex) return;

      block
        .querySelectorAll(".pickpoint")
        .forEach((p) => p.classList.remove("active"));
      pickpoint.classList.add("active");

      block
        .querySelectorAll(".featured-item")
        .forEach((item) => item.classList.remove("active"));

      const matchingItem = block.querySelector(
        `.featured-item[data-product-index="${productIndex}"]`
      );
      if (matchingItem) {
        matchingItem.classList.add("active");
      }
    }

    document.querySelectorAll(".pickpoint").forEach((pickpoint) => {
      pickpoint.addEventListener("click", function () {
        showProductForPickpoint(this);
      });
    });

    updatePickpointPositions();
    window.addEventListener("resize", updatePickpointPositions);
  }

  const atcButtons = document.querySelectorAll(".add-to-cart-icon");
  atcButtons.forEach(function (btn) {
    btn.addEventListener("click", function (event) {
      btn.querySelector("i").style.display = "none";
      btn.querySelector(".atc-loader").style.display = "inline-block";
      let productId = this.getAttribute("data-product-id");
      console.log("productId:", productId);

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: productId, quantity: 1 }),
      })
        .then((response) => response.json())
        .then((data) => {
          btn.querySelector("i").style.display = "inline-block ";
          btn.querySelector(".atc-loader").style.display = "none";
          document.querySelector("#cart-icon-bubble").click();
          // console.log("Item added to cart:", data);
        })
        .catch((error) => console.error("Error adding to cart:", error));
    });
  });

  // ✅ Initialize on page load
  initShopRoom();

  // ✅ Fix for Shopify Customizer (Reinitialize JavaScript when section reloads)
  document.addEventListener("shopify:section:load", function () {
    initShopRoom();
  });

  document.addEventListener("shopify:block:select", function () {
    initShopRoom();
  });
});
